import {createEntityService} from 'utils/createEntityService';
import {Company} from 'types/company';
import apiClient from './apiClient';

export const BaseCompanyService = createEntityService<Company>({
  baseUrl: 'api/v1/companies',
  entityName: 'company',
  methodConfigs: {
    update: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  },
});

export class CompanyService extends BaseCompanyService {
  static async getCurrent() {
    const response = await apiClient.get(`api/v1/companies/current`);
    return response.data;
  }
}
